'use client';

import React from 'react';
import Image from 'next/image';
import { classNames } from '@/shared/lib/classnames/classnames';
interface Props {
  img: {
    alt: string;
    src: string;
  };
  isTop?: boolean;
  sectionId?: string;
  isLazy?: boolean;
  className?: string;
  children?: React.ReactNode;
  isCircle?: boolean;
  isContainPhoto?: boolean;
}
export const DoctorAvatar: React.FC<Props> = props => {
  const {
    img,
    isTop = false,
    isCircle = true,
    isLazy = true,
    sectionId,
    children,
    className,
    isContainPhoto = false
  } = props;
  return <figure className={className} data-sentry-component="DoctorAvatar" data-sentry-source-file="DoctorAvatar.tsx">
      <div className="relative flex aspect-square w-44 flex-col items-end md:pl-5" id={sectionId}>
        <Image loading={isLazy ? 'lazy' : 'eager'} src={img.src} alt={img.alt} className={classNames('absolute inset-0 size-full', {
        'rounded-full md:rounded-3xl': isCircle,
        'rounded-3xl': !isCircle,
        'object-cover': !isContainPhoto,
        'object-contain': isContainPhoto
      })} width={176} height={176} data-sentry-element="Image" data-sentry-source-file="DoctorAvatar.tsx" />
        {isTop && <div className="absolute bottom-0 right-3 rounded-br-3xl rounded-tl-3xl bg-blue-600 px-5 py-2.5 text-white md:right-0">
            TOP
          </div>}
      </div>

      {children && <figcaption className="mt-2 flex items-center pt-2 md:flex-col">{children}</figcaption>}
    </figure>;
};